export default "__VITE_ASSET__CMmkYcQi__"